<template>
  <div>
    <AdjuntosOperacionCardList 
      ref="documentCardList"
      :adjuntos="documentosAdaptados" 
      modoEdicion="only-new-files" 
      :configAdjuntos="props.estructuraDocumental" 
      @documents:upload="onDocumentsUpload" />
  </div>

</template>

<script setup lang="ts">
import { type DocumentosAguaModel, type EstructuraDocumentalOperacionModel } from '@api/api';
import AdjuntosOperacionCardList, { type AdjuntoOperacion } from '@components/operacion/AdjuntosOperacionCardList.vue';
import { computed, ref } from 'vue';
import { useApi } from '@api/integration';
import type { CardFile } from '@/.shared/components/document-card/models/CardFile';
import { toastError } from '@/.shared/services/notification-service';
import { useIntl } from '@/.shared/services/i18n/i18nservice';
const emit = defineEmits(['documentoSubido']);

const props = defineProps<{
  documentos: DocumentosAguaModel[],
  idOperacion: string | undefined,
  estructuraDocumental: EstructuraDocumentalOperacionModel[]
}>();

const documentCardList = ref<InstanceType<typeof AdjuntosOperacionCardList>>();
const api = useApi();
const intl = useIntl();

const onDocumentsUpload = async () => {
  try {
    await sincronizarCambiosDocumentacion();
    emit('documentoSubido');
  }
  catch(error) {
    toastError(intl.i18n.t('operaciones.guardar_fallo'));
  }
};

const sincronizarCambiosDocumentacion = async () => {
  const files = documentCardList.value?.getFiles();

  if (files === undefined) return;
  
  const filesToSave = files.filter(f => f.status === 'new' || f.status === 'modified');

  await guardarDocumentacion(filesToSave);
}

const guardarDocumentacion = async (files: CardFile[]) => {
  const savePromises = files.map(file =>
  {    
    const typeCode = file.typeCode;
    return api.callStandardApi("postDocumentoOperacionAgua", { showLoading: true }, props.idOperacion!, typeCode!, file.description ?? undefined, file.fileName, file.file!)
  });

  await Promise.all(savePromises);
}

const documentosAdaptados = computed(() => {
  return props.documentos.map<AdjuntoOperacion>((documento: DocumentosAguaModel) => {
    return {
      Id: documento.Id!,
      Nombre: documento.Nombre,
      Ruta: documento.Ruta,
      Descripcion: documento.Descripcion,
      Tipo: documento.IdTipoDocumento,

    };
  });
});

</script>

<style lang="scss" scoped>
</style>